export default class Price {
    constructor(id = '') {
        this.ammount = 0;
        this.currency = 'MXN';
        this.id = id;
    }
}
